// extracted by mini-css-extract-plugin
export var chatHtmlText = "_sq-2";
export var chatLink = "_sq-0";
export var chatText = "_sq-1";